export default __webpack_public_path__ + "static/media/ic-cutandcarry.6a226468.svg";